import { Link } from 'react-router-dom';
import { toAbsoluteUrl } from '@/utils';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

const CheckEmail = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = params.get('email');
  const decodedEmail = email ? decodeURIComponent(email) : '';

  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  const handleResend = (e) => {
    e.preventDefault();
    // TODO: Gọi API resend ở đây nếu cần
    setCountdown(60);
  };

  return <div className="card max-w-[440px] w-full">
      <div className="card-body p-10">
        <div className="flex justify-center py-10">
          <img src={toAbsoluteUrl('/media/illustrations/30.svg')} className="dark:hidden max-h-[130px]" alt="" />
          <img src={toAbsoluteUrl('/media/illustrations/30-dark.svg')} className="light:hidden max-h-[130px]" alt="" />
        </div>

        <h3 className="text-lg font-medium text-gray-900 text-center mb-3">
          <FormattedMessage id="AUTH.VERIFY_EMAIL.CHECK_EMAIL_TITLE" />
        </h3>
        <div className="text-2sm text-center text-gray-700 mb-7.5">
          <FormattedMessage
            id="AUTH.VERIFY_EMAIL.CHECK_EMAIL_VERIFY"
            values={{
              email: <span className="text-primary font-medium">{decodedEmail}</span>,
              br: <br />
            }}
          />
        </div>

        <div className="flex justify-center mb-5">
          <Link to="/auth/login" className="btn btn-primary flex justify-center">
            <FormattedMessage id="AUTH.BACK_TO_LOGIN" />
          </Link>
        </div>

        <div className="flex items-center justify-center gap-1">
          <span className="text-xs text-gray-700">
            <FormattedMessage id="AUTH.VERIFY_EMAIL.NOT_RECEIVE" />
          </span>
          <button
            className="text-xs font-medium link"
            onClick={handleResend}
            disabled={countdown > 0}
            style={{ cursor: countdown > 0 ? 'not-allowed' : 'pointer', opacity: countdown > 0 ? 0.5 : 1 }}
          >
            {countdown > 0 ? <FormattedMessage id="AUTH.VERIFY_EMAIL.RESEND" /> : <FormattedMessage id="AUTH.VERIFY_EMAIL.RESEND" />} {countdown > 0 ? `(${countdown}s)` : ''}
          </button>
        </div>
      </div>
    </div>;
};
export { CheckEmail };